import { useState } from "react";
import type { TestSendResult } from "../../types/subscriptionSettings";

interface Props {
  destinationLabel: string;
  placeholder: string;
  disabled?: boolean;
  onSend: (destination: string) => Promise<TestSendResult>;
}

export function TestSendPanel({ destinationLabel, placeholder, disabled, onSend }: Props) {
  const [destination, setDestination] = useState("");
  const [pending, setPending] = useState(false);
  const [result, setResult] = useState<TestSendResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setPending(true);
    setError(null);
    setResult(null);
    try {
      const r = await onSend(destination);
      setResult(r);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Test send failed");
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="ac-test-send-panel">
      <h3 className="ac-test-send-panel__title">Send Test Notification</h3>
      <div className="ac-test-send-panel__row">
        <label className="ac-test-send-panel__label">
          {destinationLabel}
          <input
            type="text"
            className="ac-input"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            placeholder={placeholder}
            disabled={pending || disabled}
          />
        </label>
        <button
          type="button"
          className="ac-button ac-button--secondary"
          onClick={handleClick}
          disabled={pending || disabled}
        >
          {pending ? "Sending..." : "Send Test"}
        </button>
      </div>

      {error && <div className="ac-alert ac-alert--error">{error}</div>}
      {result && (
        <div className={`ac-alert ${result.success ? "ac-alert--success" : "ac-alert--error"}`}>
          <div className="ac-test-send-panel__result-row">
            <strong>{result.success ? "Success" : "Failure"}</strong>
            <span className="ac-test-send-panel__latency">{result.latency_ms} ms</span>
          </div>
          {result.provider_status && (
            <div className="ac-test-send-panel__detail">
              <span className="ac-test-send-panel__detail-label">Status:</span> {result.provider_status}
            </div>
          )}
          {result.provider_response && (
            <pre className="ac-test-send-panel__response">{result.provider_response}</pre>
          )}
        </div>
      )}
    </div>
  );
}
